import api from "./api";

export const deviceService = {
  findAll,
  findByCircuit,
  findDetailsForDevice,
  getDeviceStatusLive,
  reconfigureDevice,
  findEventsForDevice,
  installDevice,
  uninstallDevice,
  getDeviceConfig,
  saveDeviceConfig,
  getDeviceInstallationHistory,
  saveDeviceInstallationHistory,
  getInstallationIssues,
  getInstallationLog,
  getInstallationCounts,
  getLogsData,
  requestDownloadLogs,
  deleteHistoryLog,
  downloadLog,
  calibrateDevice
};
function findAll(onlyActiveCircuits) {
  let url = "/cable-health-broker/v1/devices"
  if (!onlyActiveCircuits) {
    url += "?inactive=true"
  }
  return api.get(url);
}

function findByCircuit(circuitUuid) {
  return api.get("/cable-health-broker/v1/devices?circuit_uuid=" + circuitUuid);
}

function findDetailsForDevice(serial) {
  return api.get("/cable-health-broker/v1/devices/" + serial);
}

function getDeviceStatusLive(serial) {
  return api.get("/cable-health-broker/v1/devices/" + serial + "/status/live");
}

function reconfigureDevice(serial, pole) {
  return api.post("/cable-health-broker/v1/devices/" + serial + "/pole/" + pole + '/force_mls');
}

function findEventsForDevice(serial) {
  return api.get(
    "/cable-health-broker/v1/devices/" + serial + "/events?sort=DESC"
  );
}

function installDevice(device) {
  return api.post(
    "/cable-health-broker/v1/devices/" +
    device.product_serial_num +
    "/pole/" +
    device.pole.uuid
  );
}

function uninstallDevice(device) {
  return api.delete(
    "/cable-health-broker/v1/devices/" +
    device.product_serial_num +
    "/pole/" +
    device.pole.uuid
  );
}

function getDeviceConfig(serial) {
  return api.get(
    "/cable-health-broker/v1/devices/" + serial + "/config"
  );
}

function saveDeviceConfig(serial, config) {
  return api.put(
    "/cable-health-broker/v1/devices/" + serial + "/config",
    config
  );
}

function getDeviceInstallationHistory(serial) {
  return api.get(
    "/cable-health-broker/v1/devices/" + serial + "/install_history"
  );
}

function saveDeviceInstallationHistory(serial, install_history) {
  return api.post("/cable-health-broker/v1/devices/" + serial + "/install_history", install_history)
}

function getInstallationIssues() {
  return api.get("/cable-health-broker/v1/installation_issues")
}

function getInstallationLog() {
  return api.get("/cable-health-broker/v1/installation_log")
}

function getInstallationCounts() {
  return api.get("/cable-health-broker/v1/installation_counts")
}


function getLogsData(serial) {
  return api.get("/cable-health-broker/v1/devices/" + serial + "/logs")
}

function requestDownloadLogs(serial) {
  return api.get("/cable-health-broker/v1/devices/" + serial + "/logs/download")
}

function deleteHistoryLog(serial, uuid) {
  return api.delete("/cable-health-broker/v1/devices/" + serial + "/logs/download/" + uuid)
}

function downloadLog(serial, uuid_) {
  return api.get("/cable-health-broker/v1/devices/" + serial + "/logs/download/" + uuid_, { responseType: 'blob' })
}

function calibrateDevice(device) {
  return api.get(
    "/cable-health-broker/v1/devices/" +
    device.product_serial_num +
    "/calibrate" 
  );
}

